"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageWithSkeleton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _variables = require("../../constants/variables");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const style = {
    height: _variables.OVERVIEW_IMAGE_HEIGHT,
    maxWidth: '165px',
    objectFit: 'cover',
    padding: 0
};
const ImageWithSkeleton = (param)=>{
    let { src, alt } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.LazyImage, {
        alt: alt,
        src: src,
        sx: style,
        fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
            animation: "wave",
            variant: "rectangular",
            width: 160,
            sx: style
        }),
        "data-testid": getTestId(_constants.IMAGE_WITH_SKELETON)
    });
};
exports.ImageWithSkeleton = ImageWithSkeleton;
